export default function useTruncateText(text: string, length: number): string {
  if (text.length <= length) return text;

  const subString = text.slice(0, length - 1);

  return subString.slice(0, subString.lastIndexOf(" "));
}
